import React from 'react';

import styles from './Spinner.module.scss';
import cx from 'clsx';
import { isEqual } from 'src/utils/lodash-alternatives';

const SPINNER_SIZE = 38;
const SPINNER_PADDING = 10;
const SPINNER_BORDER_WIDTH = 2;
const CANVAS_SIZE = SPINNER_SIZE + SPINNER_PADDING * 2;
const SPINNER_BLUE_SET = {
  disc: '#d7e3ff',
  glow: '#adc9ff',
  cometStart: '#00143c',
  cometEnd: '#d7e3ff',
};

const Spinner = ({ animation }) => {
  const { disc, glow, cometStart, cometEnd } = SPINNER_BLUE_SET;
  const radius = SPINNER_SIZE / 2 - SPINNER_BORDER_WIDTH / 2;
  const centerPoint = CANVAS_SIZE / 2;
  const arcPath = `M${centerPoint},${centerPoint -
    radius} a${radius},${radius} 0 0,0 ${-radius},${radius}`;
  const id = 'spinner';

  return (
    <div
      className={cx(styles.spinner, animation && styles.spinnerAnim)}
      data-testid="spinner"
    >
      <svg
        className={cx(styles.spinnerComp, animation && styles.spinnerCompAnim)}
      >
        <g className="currentLayer">
          <circle
            fill="none"
            stroke={disc}
            strokeWidth={SPINNER_BORDER_WIDTH}
            opacity="1"
            cx={CANVAS_SIZE / 2}
            cy={CANVAS_SIZE / 2}
            r={radius}
          />
          <path
            fill="none"
            stroke={`url(#${id}-glow)`}
            strokeWidth={SPINNER_BORDER_WIDTH}
            opacity="1"
            d={arcPath}
            filter={`url(#${id}-blur)`}
          />
          <path
            fill="none"
            stroke={`url(#${id}-spinner)`}
            strokeWidth={SPINNER_BORDER_WIDTH}
            strokeLinecap="round"
            opacity="1"
            d={arcPath}
          />
        </g>
        <defs>
          <linearGradient id={`${id}-glow`} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={glow} stopOpacity="1" />
            <stop offset="100%" stopColor={glow} stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id={`${id}-spinner`}
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stopColor={cometStart} stopOpacity="1" />
            <stop offset="100%" stopColor={cometEnd} stopOpacity="0" />
          </linearGradient>
          <filter
            id={`${id}-blur`}
            height="3"
            width="3"
            y="-1"
            x="-1"
            colorInterpolationFilters="sRGB"
          >
            <feGaussianBlur stdDeviation="2.5" />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default React.memo(Spinner, (prevProps, nextProps) =>
  isEqual(prevProps, nextProps)
);
